export const API_KEY = 'BA79-RF99-TK77-HC18';
